import React from "react";

import gettext from "../../shared/utils/gettext";
import DashboardTile from "../DashboardTile";
import cropr from "../../shared/utils/cropr";
import cx from "classnames";

type dayPart = "night" | "morning" | "afternoon" | "evening";
const hour = new Date().getHours();
const getCurPartOfDay = (): dayPart => {
  if (hour < 6) return "night";
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
};
const WeatherTile = () => {
  const partOfDay = getCurPartOfDay();
  return (
    <DashboardTile experimental>
      <DashboardTile.Title>
        {gettext("Weather in")} {cropr.farm.get("address").city},{" "}
        {cropr.farm.get("address").country}{" "}
      </DashboardTile.Title>
      {(cropr.features.dacom_online_weather && (
        <>
          {/*todo use real data*/}
          <DashboardTile.Body>
            <h5>{gettext("Today")}</h5>
            <p>
              {gettext("Spraying conditions")}: {gettext("Perfect")} (demo)
            </p>
            <table className="table">
              <tbody>
                <tr>
                  <td className={cx(partOfDay === "morning" ? "font-weight-bold" : "")}>6-12</td>
                  <td className={cx(partOfDay === "afternoon" ? "font-weight-bold" : "")}>12-18</td>
                  <td className={cx(partOfDay === "evening" ? "font-weight-bold" : "")}>18-24</td>
                  <td className={cx(partOfDay === "night" ? "font-weight-bold" : "")}>24-6</td>
                </tr>
                <tr>
                  <td>
                    <i className="fa-2x far fa-sun-cloud" />
                  </td>
                  <td>
                    <i className="fa-2x far fa-sun-cloud" />
                  </td>
                  <td>
                    <i className="fa-2x far fa-cloud" />
                  </td>
                  <td>
                    <i className="fa-2x far fa-cloud-rain" />
                  </td>
                </tr>
                <tr>
                  <td>{gettext("Dry")}</td>
                  <td>{gettext("Dry")}</td>
                  <td>{gettext("Cloudy")}</td>
                  <td>{gettext("Rain")}</td>
                </tr>
                <tr>
                  <td>5 °C</td>
                  <td>25 °C</td>
                  <td>18 °C</td>
                  <td>1 °C</td>
                </tr>
              </tbody>
            </table>
            DEMO-DATA!
          </DashboardTile.Body>
          <DashboardTile.Link
            url="/apps/dacom_online/weather/page/"
            icon="x icn_weather-forecast"
            text={gettext("Details")}
            experimental
            logMetrics={true}
          />
        </>
      )) || (
        <>
          <DashboardTile.Body>
            {
              /* gettext str needs to be one single line */
              /* prettier-ignore */ gettext("With a Dacom Weather subscription you'll have up to date weather information right at your fingertips!")
            }
          </DashboardTile.Body>
          <DashboardTile.Link
            url="/subscription/order/"
            text={gettext("Buy Dacom Weather subscription")}
            experimental
            logMetrics={true}
            extraMetricsData="upgrade_weather"
          />
        </>
      )}
    </DashboardTile>
  );
};
export default WeatherTile;
